import React from 'react';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  background-color: #000000;
  color: #FFFFFF;
  padding: 20px;
  align-items: center;
  margin: 0 auto;
  width: 80%; 

`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding:5%;
  
  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 5%;
  }
`;

const Logo = styled.div`
  display: block;
  
  img {
    width:50%;
    height:auto;
  }

  @media (max-width: 500px) {
    display: none;
  }
`;

const Logo_mobile = styled.div`
  display: none;

  @media (max-width: 500px) {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding:5% 0% 5% 0%;
  }

`;

const LinksWrapper = styled.div`
  display: flex;
  

  @media (max-width: 500px) {
    flex-direction: row;
    gap: 10px;
    align-items: flex-start;
    padding:5% 0% 10% 0%;
    justify-content: space-between; /* 确保左右两侧的链接均匀分布 */
    width: 60%; /* 充满整个宽度 */
  }
`;

const Links = styled.div`
  display: flex;
  gap: 20px;
  color: #FFFFFF;
  margin-left:20px;

  a {
    color: #FFFFFF;
    text-decoration: none;
    font-size: 18px;

    &:hover {
      color: #FFF56A;
    }
  }

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 30px;
    align-items: flex-start;
    margin-left:0px;

    a {
      color: #FFFFFF;
      text-decoration: none;
      font-size: 16px;

      &:hover {
        color: #FFF56A;
      }
    }
  }
`;



const FooterBottom = styled.div`
  margin-top: 20px;
  font-size: 16px;
  text-align: center;
  color:#FFFFFF;
  border-top: 1px solid #3F3F3F;
  margin: 0 auto;
  width: 90%; 
 

  a {
    color: #FFFFFF;
    text-decoration: none; /* 移除底線 */
    font-size: 18px;

    &:hover {
      color:#FFF56A;
    }
  }

  @media (max-width: 500px) {
    display:none;
  }

`;

const FooterBottom_mobile = styled.div`
  margin-top: 20px;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color:#FFFFFF;
  border-top: 1px solid #3F3F3F;
  margin: 0 auto;
  width: 90%; 
  display:none;

 

  a {
    color: #FFFFFF;
    text-decoration: none; /* 移除底線 */
    font-size: 14px;

    &:hover {
      color:#FFF56A;
    }
  }

  @media (max-width: 500px) {
    display:block;
  }

`;

const Footer = () => (
  <FooterWrapper>
    <FooterTop>
      <Logo><img src="/images/Footer_logo.png" alt="Footer" /></Logo>
      <Logo_mobile><img src="/images/Footer_logo_mobile_top.png" alt="Footer" /></Logo_mobile>
        <LinksWrapper>
          <Links>
        
            <a href="/">首頁</a>
            <a href="/did">DID</a>
            <a href="/dao">DAO</a>
          </Links>
          <Links>
            <a href="/retropgf">RetroPGF</a>
            <a href="/web3">web3</a>
            <a href="/info">相關資訊</a>
         
          </Links>
        </LinksWrapper>
      <Logo_mobile><img src="/images/Footer_logo_mobile_bottom.png" alt="Footer" /></Logo_mobile>
    </FooterTop>
    <FooterBottom>
      <p>
        <a href="#" target="_blank">隱私權及網站安全政策</a>&nbsp;&nbsp;&nbsp;&nbsp;© 2023 Ministry of Digital Affairs, LTD. All Rights Reserved
      </p>
    </FooterBottom>
    <FooterBottom_mobile>
      <p>
        <a href="#" target="_blank">隱私權及網站安全政策</a><br/><br/>© 2023 Ministry of Digital Affairs, LTD. All Rights Reserved
      </p>
    </FooterBottom_mobile>
  </FooterWrapper>
);

export default Footer;
